export default "__VITE_ASSET__63205dc1__"